import { useSyncExternalStore } from 'react'

type ViewportSize = {
  width: number
  height: number
}

const getViewport = (): ViewportSize => ({
  width: window.visualViewport?.width ?? window.innerWidth,
  height: window.visualViewport?.height ?? window.innerHeight,
})

let viewportSnapshot: ViewportSize | null = null

const readViewportSnapshot = () => {
  if (!viewportSnapshot) viewportSnapshot = getViewport()
  return viewportSnapshot
}

const updateViewportSnapshot = () => {
  const nextViewport = getViewport()
  const previousViewport = viewportSnapshot
  if (previousViewport?.width === nextViewport.width && previousViewport.height === nextViewport.height) return

  viewportSnapshot = nextViewport
}

const subscribeWindowSizeChange = (callback: () => void) => {
  const handleResize = () => {
    updateViewportSnapshot()
    callback()
  }

  window.addEventListener('resize', handleResize)
  window.visualViewport?.addEventListener('resize', handleResize)

  return () => {
    window.removeEventListener('resize', handleResize)
    window.visualViewport?.removeEventListener('resize', handleResize)
  }
}

/** 画面の幅と高さを取得するフック */
export const useViewport = () => {
  return useSyncExternalStore(subscribeWindowSizeChange, readViewportSnapshot, readViewportSnapshot)
}
